// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse {
    static getAttributeTypeMap() {
        return CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse.attributeTypeMap;
    }
}
CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse.discriminator = undefined;
CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse.additionalProperties = false;
CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtCardInternalStatusResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=couponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse.js.map